import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const galleryItems = [{
  label: 'Portavelas con plantilla floral',
  desc: 'Ideales para decorar y dar calidez.',
  img: 'https://cdn.magicpatterns.com/uploads/kKyiZP6ecEwbQ9erazxFM7/PORTAVELAS.jpg'
}, {
  label: 'Atrapasoles con mandalas',
  desc: 'Llená tus espacios de color y luz.',
  img: 'https://cdn.magicpatterns.com/uploads/aU9Xp5opg4tjChjXDmTw2g/ATRAPASOLES.jpg'
}, {
  label: 'Mandalas efecto vitral',
  desc: 'Diseños relajantes y vibrantes.',
  img: 'https://cdn.magicpatterns.com/uploads/3Af6BsQAVJKhsNgxkT8H4Z/MANDALAS.jpg'
}, {
  label: 'Cuadros efecto vitral',
  desc: 'Arte en vidrio para cualquier rincón.',
  img: 'https://cdn.magicpatterns.com/uploads/7kJehuVKo4E4U7txV4fdcr/CUADROS_DECORATIVOS.jpg'
}, {
  label: 'Souvenirs personalizados',
  desc: 'Pequeñas piezas personalizadas para eventos y regalos.',
  img: 'https://cdn.magicpatterns.com/uploads/6MbWjt2JpMpGMYZ5MPyWVy/SOUVENIRS.jpg'
}, {
  label: 'Fanales decorativos',
  desc: 'Iluminación cálida y colorida para cualquier ambiente.',
  img: 'https://cdn.magicpatterns.com/uploads/3eFphr55yHBHeqU2o7BwN3/FANALES.jpg'
}];
export function Gallery() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-card" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-64">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-6 font-bold leading-tight" data-id="element-65">
            Mirá todo lo que podés crear con Falso Vitral Deco
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-66">
            Usá las plantillas imprimibles para crear piezas decorativas sin
            tener que dibujar desde cero.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-10" data-id="element-67">
          {galleryItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="group relative rounded-[1.5rem] sm:rounded-[2rem] overflow-hidden aspect-[4/5] bg-deco-bg shadow-sm border border-deco-warm" data-id="element-68">
              <img src={item.img} alt={item.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-69" />
              <div className="absolute inset-0 bg-gradient-to-t from-deco-text/90 via-deco-text/30 to-transparent opacity-90" data-id="element-70" />
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-8" data-id="element-71">
                <h3 className="text-white font-serif text-lg sm:text-2xl font-bold mb-1 sm:mb-2" data-id="element-72">
                  {item.label}
                </h3>
                <p className="text-white/80 text-xs sm:text-base font-medium hidden sm:block" data-id="element-73">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-74">
          <Button onClick={scrollToPurchase} variant="secondary" className="px-10 py-4 text-base" data-id="element-75">
            QUIERO APRENDER A CREARLAS
          </Button>
        </div>
      </div>
    </section>;
}